export const ACCOUNT_TYPE_STAFF = "3";
export const ACCOUNT_TYPE_CREATOR = "300001";

export const TARIFF_FREE = "300000";

export const isStaff = (accountDetails) =>
  accountDetails?.accountTypeId === ACCOUNT_TYPE_STAFF;

export const isCreator = (accountDetails) =>
  accountDetails?.accountTypeId === ACCOUNT_TYPE_CREATOR;

export const isStaffOrCreator = (accountDetails) =>
  isStaff(accountDetails) || isCreator(accountDetails);

export const isFreeUser = () =>
  localStorage.getItem('user_trial_sub') === 'true';

export const setFreeUserFlag = (tariffId) => {
  localStorage.setItem('user_trial_sub', tariffId == TARIFF_FREE ? 'true' : 'false');
};
